class InitialDataService {

  constructor($http, AuthenticationService, $state, SolidarityUserDataService) {
    'ngInject';
    this.userDataService = SolidarityUserDataService;
    this.employeeId = AuthenticationService.getEmployeeId();
  }

  initMainData() {
    this.userDataService.setEmployee(this.employeeId);
  }
}

export default InitialDataService;



// WEBPACK FOOTER //
// ./client/app/solidarity.module/common/initialData/initialData.service.js